

import UpDownArrows from './UpDownArrows'
const MyCustomerStats = ({ticketsCount}) => {
    return (
        <div className="quickStats-block">
            <div>
                <h3>{ ticketsCount }</h3>
                <UpDownArrows />
            </div>
            <h5>My Customers<br />Waiting</h5>
        </div>
    )
}

export default MyCustomerStats